(() => {
  const dataLayer = (window.dataLayer = window.dataLayer || []);
  const EVENT_NAME = "add_to_cart";
  const SUBSCRIPTION_NAMES = ["abonnement couches", "abonnement couches culottes"];

  const textFrom = (root, selectors) => {
    if (!root) return "";
    const el = root.querySelector(selectors);
    return el ? el.textContent.trim() : "";
  };

  const findProductTitle = (button, form) => {
    if (!button && !form) return "";

    const attrTitle =
      button?.dataset.productTitle ||
      form?.dataset.productTitle ||
      button?.getAttribute("data-product-title") ||
      form?.getAttribute?.("data-product-title");
    if (attrTitle) return attrTitle.trim();

    const fromForm =
      textFrom(form, "[data-product-title]") ||
      textFrom(form, ".product__title") ||
      textFrom(form, ".product-selected-title") ||
      textFrom(button?.closest(".product"), ".product__title");
    if (fromForm) return fromForm;

    const sectionTitle = textFrom(form?.closest("section"), ".product__title");
    if (sectionTitle) return sectionTitle;

    const stickySelected = textFrom(
      document.querySelector(".sticky-buttons"),
      ".selected-product-title h3"
    );
    if (stickySelected) return stickySelected;

    const fallback = textFrom(document, ".product__title");
    return fallback;
  };

  const getSellingPlanId = (form) => {
    if (!form) return "";
    const checked = form.querySelector('input[name="selling_plan"]:checked');
    return checked?.value || "";
  };

  const getQuantity = (form) => {
    if (!form) return undefined;
    const qty = form.querySelector('input[name="quantity"]');
    if (!qty) return undefined;
    const parsed = parseInt(qty.value, 10);
    return Number.isNaN(parsed) ? undefined : parsed;
  };

  const detectType = ({ button, title, sellingPlanId }) => {
    const lowerTitle = (title || "").toLowerCase();
    if (button?.getAttribute("product-subscription") === "true") return "devis";
    if (sellingPlanId) return "devis";
    if (SUBSCRIPTION_NAMES.some((name) => lowerTitle.includes(name))) return "devis";
    if (lowerTitle.includes("abonnement")) return "devis";
    return "vente";
  };

  const buildPayload = (button, override = {}) => {
    const form = override.form || button?.closest("form");
    const title =
      override.product_title || findProductTitle(button, form);
    const variantId =
      override.variant_id || form?.querySelector('input[name="id"]')?.value;
    const sellingPlanId =
      override.selling_plan_id || getSellingPlanId(form);
    const quantity =
      override.quantity !== undefined ? override.quantity : getQuantity(form);
    const pageLocation =
      override.page_location || window.location.href;
    const pageTitle =
      override.page_title || document.title;
    const timestamp =
      override.timestamp || Date.now();
    const type =
      override.type || detectType({ button, title, sellingPlanId });

    return {
      event: EVENT_NAME,
      type,
      timestamp,
      page_location: pageLocation,
      page_title: pageTitle,
      product_title: title || undefined,
      variant_id: variantId || undefined,
      selling_plan_id: sellingPlanId || undefined,
      quantity,
    };
  };

  const pushToDataLayer = (payload) => {
    dataLayer.push(payload);
    console.log("[gtm_add_to_cart] pushed", EVENT_NAME, payload, "dl length:", dataLayer.length);
  };

  const submitHandler = (event) => {
    const form = event.target;
    if (
      !form.matches('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')
    )
      return;

    const button = event.submitter || form.querySelector('[name="add"]');
    if (!button) return;
    if (button.disabled || button.getAttribute("aria-disabled") === "true") return;

    pushToDataLayer(buildPayload(button));
  };

  const clickHandler = (event) => {
    const button = event.target.closest(
      'button[name="add"], input[type="submit"][name="add"], .product-form__submit'
    );
    if (!button) return;

    const form = button.closest("form");
    if (form && form.matches('form[action*="/cart/add"], form[data-type="add-to-cart-form"]'))
      return; // submit handler will cover it
    if (button.disabled || button.getAttribute("aria-disabled") === "true") return;

    pushToDataLayer(buildPayload(button));
  };

  // Expose a manual trigger for flows that do not submit/click a standard add button.
  window.gtmAddToCart = (options = {}) => {
    const payload = buildPayload(options.button || null, options);
    pushToDataLayer(payload);
  };

  document.addEventListener("submit", submitHandler, true);
  document.addEventListener("click", clickHandler, true);
})();
